<script setup>
import { vElementSize } from '@vueuse/components'

const props = defineProps({
  opacity: String,
  alt: String,
  filename: String,
  classes: String,
})

const getWidth = ref(0)
const getHeight = ref(0)

function onResize({ width, height }) {
  getWidth.value = width
  getHeight.value = height
}
function handleClick(e) {
  e.preventDefault()
}
</script>

<template>
  <div class="relative w-full" @contextmenu.prevent="handleClick">
    <div
      :style="{
        maxWidth: `${getWidth}px`,
        maxHeight: `${getHeight}px`,
      }"
      :class="opacity"
      class="absolute inset-0 h-full w-full"
    >
      <div :class="classes" class="absolute inset-0 z-3 h-full w-full bg-primary opacity-20 mix-blend-soft-light" />
      <div :class="classes" class="absolute inset-0 z-2 h-full w-full from-[#3922B2] to-primary from-50% bg-gradient-to-r opacity-20 mix-blend-soft-light" />
      <div :class="classes" class="absolute inset-0 z-1 h-full w-full bg-primary opacity-10 mix-blend-color" />
    </div>
    <nuxt-img v-element-size="onResize" width="1100" height="732" loading="lazy" sizes="lg:1100px, sm:700px, 400px" :alt="alt" class="h-full w-full" :class="classes" :src="filename" />
  </div>
</template>
